import actionTypes from './actionTypes'

export default {
	userConnectSuccess: () => {
		return {
			type: actionTypes.USER_CONNECT_SUCCESS,
		}
	},

	userInteractionUpdate: () => {
		return {
			type: actionTypes.USER_INTERACTION_UPDATE,
		}
	},
}
